import React, { useState } from 'react';
import {
  PLANOS,
  PERIODOS_CONTRATACAO,
  FAQ_ITEMS,
  WHATSAPP_NUMBER,
  calcularValorCheckout,
  formatarMoeda,
  rotuloPrecoMensal,
  rotuloTotalPeriodo,
} from '../config/plansConfig';
import { iniciarCheckout } from '../services/checkoutService';
import './PlanosPage.css';

const periodos = Object.values(PERIODOS_CONTRATACAO);

const PlanosPageContent = () => {
  const [selectedPlano, setSelectedPlano] = useState(null);
  const [periodoSelecionado, setPeriodoSelecionado] = useState(PERIODOS_CONTRATACAO.anual.id);
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [documento, setDocumento] = useState('');
  const [telefone, setTelefone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [openFaq, setOpenFaq] = useState(null);

  const checkoutSucesso = new URLSearchParams(window.location.search).get('checkout') === 'sucesso';
  const periodo = periodos.find((p) => p.id === periodoSelecionado);
  const resumo = selectedPlano ? calcularValorCheckout(selectedPlano, periodoSelecionado) : null;

  const closeCheckout = () => {
    setSelectedPlano(null);
    setError(null);
    setLoading(false);
  };

  async function handleSubmit(e) {
    e.preventDefault();
    if (!selectedPlano) return;
    setLoading(true);
    setError(null);
    try {
      const result = await iniciarCheckout({
        produtoCodigo: selectedPlano.codigo,
        periodoContratacao: periodoSelecionado,
        nome,
        email,
        documento,
        telefone,
      });
      window.location.href = result.checkoutUrl;
    } catch (err) {
      setError(err.message || 'Erro ao iniciar pagamento.');
      setLoading(false);
    }
  }

  return (
    <div className="planos-page">
      <section className="planos-hero">
        <div className="container">
          <p className="planos-kicker">Planos Convertrex</p>
          <h1>Escolha como você quer crescer</h1>
          <p className="planos-lead">
            Contrate o ecossistema no ritmo do seu Studio: comece pelo comercial e evolua para a
            operação completa com Converlead e AXYS.
          </p>
          {checkoutSucesso && (
            <div className="checkout-success-banner" role="status">
              Pagamento recebido. Em breve falamos com você para concluir a implantação.
            </div>
          )}
        </div>
      </section>

      <section className="planos-section">
        <div className="container">
          <div className="period-switch" role="tablist" aria-label="Modelo de contratação">
            {periodos.map((item) => (
              <button
                key={item.id}
                type="button"
                role="tab"
                aria-selected={periodoSelecionado === item.id}
                className={`period-chip${periodoSelecionado === item.id ? ' is-active' : ''}${
                  item.destaque ? ' is-best' : ''
                }`}
                onClick={() => setPeriodoSelecionado(item.id)}
              >
                <strong>{item.label}</strong>
                <span>{item.descricao}</span>
              </button>
            ))}
          </div>

          <div className="planos-grid">
            {PLANOS.map((plano) => {
              const calc = calcularValorCheckout(plano, periodoSelecionado);
              const preco = rotuloPrecoMensal(plano, calc);
              const totalLabel = plano.checkout ? rotuloTotalPeriodo(calc) : null;
              return (
                <article
                  key={plano.id}
                  className={`plano-card${plano.destaque ? ' plano-card--destaque' : ''}`}
                >
                  {plano.badge && <span className="plano-badge">{plano.badge}</span>}
                  <h3>{plano.nome}</h3>
                  <p className="plano-subtitulo">{plano.subtitulo}</p>
                  <p className="plano-preco">
                    {preco.principal}
                    {preco.secundario && <span className="plano-preco-de">{preco.secundario}</span>}
                  </p>
                  {totalLabel && <p className="plano-total">{totalLabel}</p>}
                  {plano.notaPreco && <p className="plano-nota">{plano.notaPreco}</p>}
                  <ul>
                    {plano.features.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                    {plano.featuresEmBreve?.map((item) => (
                      <li key={item.texto} className="feature-soon">
                        {item.texto} <span className="soon-badge">Em evolução</span>
                      </li>
                    ))}
                  </ul>
                  {plano.checkout ? (
                    <button type="button" className="plano-cta" onClick={() => setSelectedPlano(plano)}>
                      {plano.cta}
                    </button>
                  ) : (
                    <a
                      className="plano-cta"
                      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(plano.whatsappMessage)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {plano.cta}
                    </a>
                  )}
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <section className="planos-billing">
        <div className="container">
          <h2>Modelo de contratação</h2>
          <div className="billing-grid">
            {periodos.map((item) => (
              <article
                key={item.id}
                className={`billing-card${item.destaque ? ' billing-card--destaque' : ''}`}
              >
                {item.badge && <span className="billing-badge">{item.badge}</span>}
                <h3>{item.label}</h3>
                <p className="billing-desc">{item.descricao}</p>
                <p className="billing-detalhe">{item.detalhe}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="planos-faq">
        <div className="container">
          <h2>Perguntas frequentes</h2>
          <div className="faq-list">
            {FAQ_ITEMS.map((item, index) => (
              <div className={`faq-item${openFaq === index ? ' is-open' : ''}`} key={item.pergunta}>
                <button
                  type="button"
                  className="faq-question"
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                >
                  {item.pergunta}
                  <span>{openFaq === index ? '−' : '+'}</span>
                </button>
                {openFaq === index && <p className="faq-answer">{item.resposta}</p>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {selectedPlano && (
        <div className="checkout-overlay" role="dialog" aria-modal="true">
          <div className="checkout-modal">
            <button type="button" className="checkout-close" onClick={closeCheckout} aria-label="Fechar">
              ×
            </button>
            <div className="checkout-grid">
              <aside className="checkout-summary">
                <p className="checkout-label">Resumo</p>
                <h3>{selectedPlano.nome}</h3>
                <p>{selectedPlano.subtitulo}</p>
                <ul>
                  <li>Período: {periodo?.label}</li>
                  {resumo && (
                    <li>
                      Equivalente: {formatarMoeda(resumo.valorMensalEfetivo)}/mês
                      {resumo.periodo.descontoPercentual > 0
                        ? ` (−${resumo.periodo.descontoPercentual}%)`
                        : ''}
                    </li>
                  )}
                  {resumo && <li>Total agora: {formatarMoeda(resumo.valorTotal)}</li>}
                </ul>
                <p className="checkout-footnote">
                  Pagamento seguro via Payment Hub Convertrex (Pix, cartão ou boleto).
                </p>
              </aside>
              <form className="checkout-form" onSubmit={handleSubmit}>
                <h3>Seus dados</h3>
                {error && <p className="checkout-error">{error}</p>}
                <label>
                  Nome completo
                  <input value={nome} onChange={(e) => setNome(e.target.value)} required />
                </label>
                <label>
                  E-mail
                  <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                </label>
                <label>
                  CPF/CNPJ (opcional)
                  <input value={documento} onChange={(e) => setDocumento(e.target.value)} />
                </label>
                <label>
                  Telefone / WhatsApp (opcional)
                  <input value={telefone} onChange={(e) => setTelefone(e.target.value)} />
                </label>
                <div className="checkout-actions">
                  <button type="button" className="checkout-cancel" onClick={closeCheckout}>
                    Voltar
                  </button>
                  <button type="submit" className="checkout-submit" disabled={loading || !nome || !email}>
                    {loading ? 'Abrindo checkout…' : 'Ir para pagamento'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PlanosPageContent;
